import {
  buildTitleRouteHref,
  DEFAULT_LOCALE,
  isAppLocale,
  type TitleRouteHref
} from '../i18n/localizedRoutes';

function buildTitleUrl({
  type,
  shortId,
  slugs,
  locale,
  queries
}: {
  type: 'movie' | 'tv';
  shortId: string;
  slugs?: {
    slug: string;
    iso_3166_1: string;
  }[];
  locale: string;
  queries?: { name: string; value: string }[];
}): TitleRouteHref {
  if (type !== 'movie' && type !== 'tv') {
    throw new Error(`Unsupported title type: ${String(type)}`);
  }

  const query = Object.fromEntries(
    (queries || [])
      .filter(item => item.value)
      .map(item => [item.name, item.value])
  );
  const normalizedLocale = locale.toLowerCase();

  return buildTitleRouteHref({
    type,
    shortId,
    slugs,
    locale: isAppLocale(normalizedLocale) ? normalizedLocale : DEFAULT_LOCALE,
    ...(Object.keys(query).length > 0 ? { query } : {})
  });
}

export default buildTitleUrl;
